import Enumeration from 'Lib/utilities/Enumeration';

const Notes = new Enumeration([
    { id: 2049, name: 'Update Notes' }
]);

export default Notes;
